import { capitalizeAllIfLower, capitalizeIfLower, formatDate } from '@btime/helpers'
import { compose, pathOr } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { RefetchingIndicator } from '../../../../../components/helpers/StatePresenter'
import { useOpenServiceOrderModal } from '../../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../../components/tables/Table'
import { useServiceOrdersActionsList } from '../../../../../utils/actions/serviceOrders/list'
import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../../packages/kiti/components/actions/Link'
import RelatedServiceOrdersLoader, { useRelatedServiceOrders } from './_load/RelatedServiceOrdersLoader'
import StatusTag from '../../../../../containers/serviceOrders/StatusTag'
import Text, { SmallText } from '../../../../../packages/kiti/components/presentation/Text'

const RelatedServiceOrderssList = () => {
  const serviceOrders = useRelatedServiceOrders()
  const openDetailsModal = useOpenServiceOrderModal()
  const canViewServiceOrderInternalId = useSessionPermission('canViewServiceOrderInternalId')

  const columns = [
    {
      label: `Nome `,
      headerSideContent: (
        <>
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'yearlyId',
      sortIndex: 'YEARLY_ID',
      flex: 3,
      render: (value, record) => {
        const checklistName = compose(
          capitalizeIfLower,
          pathOr('Resolução de não conformidade', ['checklist', 'name'])
        )(record)
        const name = record.name

        return (
          <Link onClick={() => openDetailsModal(record)} block>
            {canViewServiceOrderInternalId && (
              <SmallText size="xxsmall" color="dark3">{`#${record.id}`}</SmallText>
            )}
            <SmallText size="xsmall" color="dark3">
              {record.yearlyId}
            </SmallText>
            <Text bold color="dark2" breakWord>
              {name || checklistName}
            </Text>

            {name && (
              <SmallText size="xxsmall" color="dark3" breakWord>
                {checklistName}
              </SmallText>
            )}
          </Link>
        )
      }
    },

    {
      label: 'Usuário/Grupo',
      dataIndex: 'user',
      sortIndex: 'USER_NAME',
      format: (user, record) => capitalizeAllIfLower(user.name ?? record.group?.name),
      flex: 2.5
    },

    {
      label: 'Data de criação',
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      format: formatDate('DD/MM/YY HH:mm')
    },

    {
      label: 'Status',
      dataIndex: 'status',
      sortIndex: 'STATUS_ID',
      flex: 2,
      render: (value, record) => <StatusTag item={value} />
    },

    {
      label: 'Ações',
      flex: 1,
      render: useRowActionsColumn(useServiceOrdersActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={serviceOrders} inPanel size="medium" />
}

const Wrapper = () => (
  <RelatedServiceOrdersLoader>
    <RelatedServiceOrderssList />
  </RelatedServiceOrdersLoader>
)

export default Wrapper
